export const countries = [
  "Bahamas, The",
  "Dom. Rep",
  "Trinidad-Tobago",
  "Czechoslovakia/Czechia",
  "Slovak Rep",
  "Serbia/Yugoslavia",
  "St. Vincent and the Grenadines",
  "CAR",
  "UK",
  "Republic of North Macedonia",
  "Congo Dem R",
  "Equat. Guinea",
  "Brunei Darussalam",
  "Korea, South",
  "Korea, North",
  "Lao PDR",
  "U A Emirates",
  "Viet Nam",
  "Republic of South Sudan",
  "St. Lucia",
  "Lybia",
  "Swaziland",
  "USA"
]

export const normalizedCountries = [
  "Bahamas",
  "Dominican Rep.",
  "Trinidad and Tobago",
  "Czechia",
  "Slovakia",
  "Serbia",
  "St. Vin. and Gren.",
  "Central African Rep.",
  "United Kingdom",
  "Macedonia",
  "Dem. Rep. Congo",
  "Eq. Guinea",
  "Brunei",
  "South Korea",
  "North Korea",
  "Laos",
  "United Arab Emirates",
  "Vietnam",
  "S. Sudan",
  "Saint Lucia",
  "Libya",
  "Eswatini",
  "United States of America"
]

export const observatoryCountries = [
  "Taiwan (Pr.de Ch.)",
  "Estados Unidos",
  "Kazjastán",
  "Kuwait",
  "Qatar",
  "EAU"
]

export const observatoryCountriesHeatMap = [
  "Taiwan",
  "Estados Unidos",
  "Kazjastán",
  "Kuwait",
  "Qatar",
  "EAU"
]

export const observatoryNormalizedCountriesHeatMap = [
  "Taiwán",
  "Estados Unidos de América",
  "Kazajstán",
  "Kuwait",
  "Katar",
  "Emiratos Árabes Unidos"
]

export const observatoryNormalizedCountries = [
  "Taiwan",
  "Estados Unidos de América",
  "Kazajstán",
  "Kuwait",
  "Katar",
  "Emiratos Árabes Unidos"
]

export const translateCountries = [
  "Argentina",
  "Bahamas",
  "Barbados",
  "Belice",
  "Bolivia",
  "Brasil",
  "Chile",
  "Colombia",
  "Costa Rica",
  "Cuba",
  "República Dominicana",
  "Ecuador",
  "El Salvador",
  "Guatemala",
  "Guyana",
  "Haití",
  "Honduras",
  "Jamaica",
  "México",
  "Nicaragua",
  "Panamá",
  "Paraguay",
  "Perú",
  "San Cristóbal y Nieves",
  "Santa Lucia",
  "San Vicente y las Granadinas",
  "Surinam",
  "Trinidad y Tobago",
  "Uruguay",
  "Venezuela",
  "Albania",
  "Austria",
  "Bélgica",
  "Bielorrusia",
  "Bulgaria",
  "Croacia",
  "Chipre",
  "República Checa",
  "Dinamarca",
  "Estonia",
  "Finlandia",
  "Francia",
  "Alemania",
  "Grecia",
  "Hungría",
  "Islandia",
  "Irlanda",
  "Italia",
  "Letonia",
  "Lituania",
  "Malta",
  "Moldavia",
  "Países Bajos",
  "Noruega",
  "Polonia",
  "Portugal",
  "Rumania",
  "Rusia",
  "Eslovaquia",
  "Eslovenia",
  "España",
  "Suecia",
  "Suiza",
  "Ucrania",
  "Reino Unido",
  "Serbia",
  "Argelia",
  "Angola",
  "Benín",
  "Botsuana",
  "Burkina Faso",
  "Burundi",
  "Camerún",
  "República Centroafricana",
  "Chad",
  "República del Congo",
  "República Democrática del Congo",
  "Costa de Marfil",
  "Egipto",
  "Guinea Ecuatorial",
  "Eritrea",
  "Etiopía",
  "Gabón",
  "Gambia",
  "Ghana",
  "Guinea",
  "Guinea-Bisáu",
  "Kenia",
  "Lesoto",
  "Liberia",
  "Libia",
  "Madagascar",
  "Malaui",
  "Malí",
  "Mauritania",
  "Mauricio",
  "Marruecos",
  "Mozambique",
  "Namibia",
  "Niger",
  "Nigeria",
  "Ruanda",
  "Santo Tomé y Príncipe",
  "Senegal",
  "Seychelles",
  "Sierra Leona",
  "Sudáfrica",
  "Sudán",
  "Sudán del sur",
  "Suazilandia",
  "Tanzania",
  "Togo",
  "Túnez",
  "Uganda",
  "Zambia",
  "Zimbabue",
  "Afganistán",
  "Armenia",
  "Azerbaiyán",
  "Baréin",
  "Bangladés",
  "Brunéi",
  "Camboya",
  "China",
  "Hong Kong",
  "Georgia",
  "India",
  "Indonesia",
  "Irán",
  "Iraq",
  "Israel",
  "Japón",
  "Jordania",
  "Kazajistán",
  "Corea del Sur",
  "Corea del Norte",
  "Kuwait",
  "Kirguistán",
  "Laos",
  "Líbano",
  "Malasia",
  "Mongolia",
  "Birmania",
  "Nepal",
  "Omán",
  "Pakistán",
  "Filipinas",
  "Catar",
  "Arabia Saudita",
  "Singapur",
  "Sri Lanka",
  "Siria",
  "Taiwan",
  "Tayikistán",
  "Tailandia",
  "Turquía",
  "Emiratos Árabes Unidos",
  "Uzbekistán",
  "Vietnam",
  "Yemen",
  "Australia",
  "Nueva Zelanda",
  "Canadá",
  "Estados Unidos de América",
  "Latino América",
  "Europa del Este",
  "África subsahariana",
  "Norte de África",
  "Oriente Medio",
  "Asia Oriental",
  "Sur de Asia",
  "Ramificaciones Occidentales",
  "Europa Occidental",
  "Mundo",
  "OECD",
  "Resto del mundo"
]
